export const wantToAchiveAnswerImages = new Map([
  [
    1,
    {
      url: "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/onboarding/savingMoney.svg",
      alt: "Mentoro saving money",
    },
  ],
  [
    2,
    {
      url: "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/onboarding/manageDebt.svg",
      alt: "Mentoro manage debt",
    },
  ],
  [
    3,
    {
      url: "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/onboarding/buildWealth.svg",
      alt: "Mentoro build wealth debt",
    },
  ],
  [
    4,
    {
      url: "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/onboarding/retirement.svg",
      alt: "Mentoro retirement",
    },
  ],
  [
    5,
    {
      url: "https://mentoro-assets.s3.us-west-1.amazonaws.com/portals/public/participant/onboarding/insurance.svg",
      alt: "Mentoro insurance",
    },
  ],
]);
